import type { LoadedFspValues } from "@fero/hooks";
import type { StockListing } from "adl-gen/ferovinum/app/api";
import { assertNotUndefined } from "utils/hx/util/types";

export function extractDealLegs(stockDataMap: Map<string, StockListing[]>) {
  return [...stockDataMap.values()].flatMap((sls) =>
    sls.map((sl) => sl.productDealLeg),
  );
}

export function buildFspValuesMap(
  stockDataMap: Map<string, StockListing[]>,
  fspValues: LoadedFspValues,
) {
  // map by product code
  const result: Record<string, LoadedFspValues> = {};

  for (const entry of stockDataMap.entries()) {
    const productFspValues: LoadedFspValues = {};
    const code = entry[0];
    const stockListing = entry[1];
    stockListing.forEach(
      (listing) =>
        (productFspValues[listing.productDealLeg.dealLegWithDbId.id] =
          fspValues[listing.productDealLeg.dealLegWithDbId.id]),
    );

    result[code] = productFspValues;
  }
  return result;
}

export function makeStockRowData(stockListings: Map<string, StockListing[]>) {
  return [...stockListings.keys()].map((code) => {
    const listings = assertNotUndefined(stockListings.get(code));
    return { code, listings };
  });
}
